import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AppState } from 'src/app/app.reducer';
import { Store } from '@ngrx/store';
import {
  AddReplacementPattern,
  GetReplacementPatternDetails,
  EditReplacementPattern,
} from '../../store/templates.actions';
import { debounceTime } from 'rxjs/operators';
import { ValidationUtil, VALIDATION_MESSAGES } from "../../../../../utils/validation.util";

@Component({
  selector: 'app-add-replacement-pattern-dialog',
  templateUrl: './add-replacement-pattern-dialog.component.html',
  styleUrls: ['./add-replacement-pattern-dialog.component.scss']
})
export class AddReplacementPatternDialogComponent implements OnInit {
  addReplacementPatternForm: FormGroup;
  invalidPattern: boolean = false;
  validationMsg = VALIDATION_MESSAGES;

  constructor(
    private dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private store: Store<AppState>,
    private fb: FormBuilder,
  ) {
    this.dialogRef.disableClose = true;
  }

  ngOnInit() {
    this.addReplacementPatternForm = this.fb.group({
      term: ["", Validators.compose([
        Validators.required,
        Validators.pattern('%[A-Za-z0-9]{3,}%$'),
      ])],
      details: ["", Validators.compose([
        Validators.required,
        ValidationUtil.cannotBeBlank,
      ])]
    });

    if (this.data.type == "edit") {
      this.store.dispatch(new GetReplacementPatternDetails(this.data.patternId));
      this.store.select(state => state.template.replacementPatternDetails).subscribe((response: any) => {
        if (Object.keys(response).length) {
          this.addReplacementPatternForm.get('term').setValue(response.patternCode);
          this.addReplacementPatternForm.get('details').setValue(response.patternName);
        }
      });
    }
    this.addReplacementPatternForm.get('term').valueChanges.pipe(debounceTime(300)).subscribe((value => {
      this.invalidPattern = !(new RegExp(/%[A-Za-z0-9]{3,}%$/).test(value));
    }));
  }

  onCloseDialog(): void {
    this.dialogRef.close();
  }

  submitForm() {
    if (this.addReplacementPatternForm.invalid) {
      return false;
    }
    const payload = {
      patternCode: this.addReplacementPatternForm.value.term.trim(),
      patternName: this.addReplacementPatternForm.value.details.trim(),
    }

    if (this.data.type == "edit") {
      this.store.dispatch(new EditReplacementPattern(this.data.patternId, payload));
    } else {
      this.store.dispatch(new AddReplacementPattern(payload));
    }
    this.dialogRef.close();
  }
}
